//==================================================================================================
//  ユーティリティー
//==================================================================================================
import { QuerySnapshot, DocumentSnapshot } from 'firebase/firestore';
//==================================================================================================
//
//==================================================================================================
export class FirestoreUtil {
  //================================================================================================
  //  リスト
  //================================================================================================
  static createList<T>(querySnapshot: QuerySnapshot): Array<T> {
    let docs: Array<T> = [];
    querySnapshot.docs.forEach((documentSnapshot) => {
      const docData = documentSnapshot.data();
      let docCopy = { 'doc_id': documentSnapshot.id, ...docData } as T;
      docs.push(docCopy);
    });
    return docs;
  }
  //================================================================================================
  //  ドキュメント
  //================================================================================================
  static createDoc<T>(documentSnapshot: DocumentSnapshot): T | null {
    let doc: T | null = null;
    if (documentSnapshot.exists()) {
      const docData = documentSnapshot.data();
      let docCopy = { 'doc_id': documentSnapshot.id, ...docData } as T;
      doc = docCopy;
    }
    return doc;
  }

}
